"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgDatabase12Px = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 80 80" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#666", d: "M75 6a1 1 0 0 1 1 1v21a.995.995 0 0 1-.134.5.993.993 0 0 1 .134.5v21a.995.995 0 0 1-.134.501A.982.982 0 0 1 76 51v21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V51c0-.182.049-.353.134-.5A.993.993 0 0 1 4 50V29c0-.182.049-.353.134-.5A.993.993 0 0 1 4 28V7a1 1 0 0 1 1-1Zm0 45H5v21h70V51Zm0-22H5v21h70V29Zm0-22H5v21h70V7Z" }),
        React.createElement("path", { fill: "#BFBFBF", d: "M64 59v5H48v-5h16Zm0-22v5H48v-5h16Zm0-22v5H48v-5h16Z" }))));
const Memo = (0, react_1.memo)(SvgDatabase12Px);
exports.default = Memo;
//# sourceMappingURL=Database12Px.js.map